module.exports = __webpack_public_path__ + "img/expense_category_transportation.e89e758.png";